<template>
  <!-- More two variable  -->
  <div>
    <div class="header-order">
      <span>
        {{ endDate }}
      </span>
      <span>
        {{ daoRequest.name }}
      </span>
      <span>
        {{ daoRequest.description }}
      </span>
    </div>
    <div class="body-order">
      <div class="graph">
        <span>{{ $t("daoTokens.survey.results") }}</span>
        <div class="chart-wrapper">
          <Apexchart
            height="160px"
            type="donut"
            :options="isEmptyChart ? options : optionsDefault"
            :series="isEmptyChart ? series.perсent : seriesDefault"
          />
        </div>
      </div>
      <div class="vote">
        <div
          v-if="daoRequest?.daoEvents"
          class="vote-result"
        >
          <span>
            {{ $t("daoTokens.survey.alreadyVote") }}:&nbsp;
          </span>
          <span>
            {{ daoRequest?.daoEvents[0].name }}
          </span>
        </div>
        <span>{{ $t("daoTokens.survey.choose") }}</span>
        <div class="vote-wrapper">
          <div
            v-for="(item, index) in daoRequest.result"
            :key="index"
            class="main_container"
          >
            <label class="radio-container">
              <input
                v-model="radioInfo"
                type="radio"
                name="radio"
                :value="item.id"
                @change="openConfirmDialog"
              >
              <span class="checkmark many" />
              <span class="answer">{{ item.name }}</span>
            </label>
          </div>
        </div>
      </div>
    </div>
    <AuDialogModal
      v-model="showDialogModal"
      :body-text="confirmPhrase"
      @confirm="getVoice"
      @decline="radioInfo=null"
    />
  </div>
</template>

<script>
import _ from "lodash";
import moment from "moment";

export default {
  props: {
    daoRequest: {
      type: Object,
      default: () => {},
      required: true
    },
    userData: {
      type: Object,
      default: () => {},
      required: true
    },
    ownerAmount: {
      type: Number,
      default: 0,
      required: true
    }
  },

  data() {
    return {
      showDialogModal: false,
      radioInfo: null,
      amount: null,
      optionsDefault: {
        colors: ["#b3b3b3"],
        dataLabels: {
          enabled: false
        },
        pie: {
          expandOnClick: false
        },
        legend: {
          show: false
        },
        tooltip: {
          enabled: false
        }
      },
      seriesDefault: [1]
    };
  },

  computed: {
    isEmptyChart() {
      return _.reduce(this.series.count, (acc, el) => acc + el, 0) !== 0;
    },
    endDate() {
      const date = moment(this.daoRequest.endAt);
      return date.isSame(moment(), "day")
        ? `${this.$t("daoTokens.survey.today")} ${date.format("hh:mm")}`
        : date.format("DD.MM.YYYY");
    },
    isCanVote() {
      return this.ownerAmount >= this.daoRequest.tokenLimit;
    },
    confirmPhrase() {
      let res = _.get(_.find(this.daoRequest.result, res => res.id == this.radioInfo), "name");
      return `${this.$t("daoTokens.survey.want")} "${res}" ${this.$t("daoTokens.survey.question")} "${this.daoRequest.name}"?`;
    },
    series() {
      const count = [];
      let sum = null;
      _.forEach(this.daoRequest?.result, el => {
        count.push(el.count);
        sum += el.count;
      });

      const perсent = _.map(count, (el) => Math.round(((el * 100) / sum) * 10) / 10);
      return { count, perсent };
    },
    options() {
      const labels = [];
      this.daoRequest.result.forEach((element) => {
        labels.push(element.name);
      });

      return {
        labels: labels,
        // pie: {
        //   expandOnClick: false,
        //   donut: {
        //     size: "100%"
        //   },
        //   customScale: 0.1
        // },
        dataLabels: {
          enabled: false
        },
        legend: {
          show: true,
          fontSize: "11px",
          fontFamily: "Suisse Intl",
          labels: {
            colors: [this.isLightTheme ? "#080808" : "#FFFFFF"]
          },
          markers: {
            width: 12,
            height: 8
          },
          formatter: function (seriesName, opts) {
            return [
              seriesName,
              " - ",
              opts.w.globals.series[opts.seriesIndex],
              "%"
            ];
          }
        }
      };
    },
    isLightTheme() {
      return this.$store.getters.isLightTheme;
    }
  },

  mounted() {
    this.amount = this.daoRequest?.tokenLimit;
  },

  methods: {
    openConfirmDialog() {
      if (this.isCanVote) {
        this.showDialogModal = true;
      }
      else {
        this.radioInfo = null;
        this.$toast.error(this.$t("daoTokens.survey.dontEnough"));
      }
    },

    async getVoice() {
      const params = {
        element: `/api/dao_elements/${this.radioInfo}`,
        value: true,
        user: this.userData[0].user,
        createdAt: new Date(),
        address: `/api/eth_addresses/${this.userData[0].id}`,
        amount: String(this.amount)
      };
      try {
        await this.axios.post("api/dao_events", params);
        this.$emit("newDaoRequest");
      }
      catch (error) {
        this.$toast.error(this.$t("daoTokens.survey.error")
          + " " + error.response.data.message);
        console.log(error);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.header-order {
  display: grid;
  grid-template-columns: 1fr 2fr 2fr;
  padding: 20px 0;
  border-bottom: 1px dashed var(--border-color);
}

.body-order {
  display: grid;
  grid-template-columns: 3fr 2fr;
  border-bottom: 1px dashed var(--color-50);
  padding: 20px 0;
}

.graph {
  display: flex;
  flex-direction: column;
  align-items: start;

  span {
    width: 350px;
    display: flex;
    justify-content: center;
  }
}

.vote {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}

.chart-wrapper {
  width: 350px;
  position: relative;
  @media screen and (max-width: 576px) {
    margin-left: -120px;
  }
}
.col,
.col-3,
.col-4,
.col-5,
.col-7 {
  padding: 0;
}

.row > * {
  padding-left: 0;
  padding-right: 0;
}
input {
  display: none;
}
.vote-wrapper {
  display: flex;
  flex-direction: column;
  margin-top: 10px;
  .main_container {
    display: flex;
    margin: 6px;
  }
  .radio-container {
    display: flex;
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  .radio-container input {
    opacity: 0;
    cursor: pointer;
  }
  .checkmark {
    padding: 2px;
    height: 24px;
    width: 24px;
    background-color: transparent;
    &.many {
      border: 1px solid #ed8805;
      color: #ed8805;
    }
    border-radius: 50%;
  }
  .answer {
    font-size: 10px;
    margin-top: 2px;
    margin-left: 6px;
  }
  .checkmark:after {
    display: none;
    border: 1px solid;
    border-radius: 50%;
    font-size: 16px;
    justify-content: center;
    align-items: center;
  }
  .checkmark.many:after {
    content: "✓";
  }

  .radio-container input:checked ~ .checkmark:after {
    display: flex;
  }
  .radio-container .checkmark:after {
    height: 100%;
    align-items: center;
  }
}
.left-indent {
  padding-right: 39px;
}
.down_block {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.gray-text {
  color: var(--color-50);
  font-size: 10px;
}
.vote-result {
  font-size: 10px;
}
</style>
